module.exports = __webpack_public_path__ + "static/img/PSWu.png";